import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
  MatNoDataRow,
} from '@angular/material/table';
import { Router } from '@angular/router';
import { Subject, takeUntil, tap } from 'rxjs';
import { MatIconButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import {
  MatFormField,
  MatPrefix,
  MatSuffix,
} from '@angular/material/form-field';
import { MatToolbar } from '@angular/material/toolbar';
import { UserKeycloak } from '../shared/interfaces/keycloak/userKeycloak';
import { AdherentService } from '../shared/services/adherent.service';

@Component({
  selector: 'app-pfa-interne',
  templateUrl: './pfa-interne.component.html',
  styleUrl: './pfa-interne.component.scss',
  standalone: true,
  imports: [
    MatToolbar,
    MatFormField,
    MatIcon,
    MatPrefix,
    MatInput,
    FormsModule,
    MatIconButton,
    MatSuffix,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatNoDataRow,
    MatPaginator,
  ],
})
export class PFAInterneComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly _destroying$ = new Subject<void>();
  // Table
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: string[] = [
    'code',
    'lastName',
    'firstName',
    'email',
    'actions',
  ];
  dataSource = new MatTableDataSource<UserKeycloak>();
  // Filter
  globalFilter = '';
  // list fournisseur
  listUsersAD!: UserKeycloak[];

  constructor(
    private readonly router: Router,
    private readonly AdherentService: AdherentService
  ) {}

  ngOnInit(): void {
    this.onTabSelected(2);
    this.fetchAllUser();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  /**
   * Called when the component is destroyed. Unsubscribes from all subscriptions to prevent memory leaks.
   */
  ngOnDestroy() {
    this._destroying$.next();
    this._destroying$.complete();
  }

  /**
   * Retrieves the list of all suppliers via the supplierService service.
   * The data is stored in the listLournisseurs property.
   */
  private fetchAllUser() {
    this.AdherentService.ListKeycloakUserWithoutAdherents()
      .pipe(
        takeUntil(this._destroying$),
        tap((data: UserKeycloak[]) => {
          this.listUsersAD = data;
          this.manageDataSourceTable(this.listUsersAD);
        })
      )
      .subscribe();
  }

  /**
   * Sets the array of data as the source for a data table called "dataSource".
   * @param data An array of data to set as the source for the data table.
   */
  private manageDataSourceTable(data: UserKeycloak[]) {
    if (data) {
      this.dataSource.data = data;
    }
  }

  /**
   * Manages the filters to apply for the search bar
   * If the table has pagination then the pagination is placed on the first page
   * @param filter The value of the applied filter
   */
  applyFilter(event: string) {
    this.globalFilter = event || '';
    this.dataSource.filter = this.globalFilter.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  /**
   * navigate to link adherents view
   * @param row Data of a selected row
   */
  goToLinkAdherents(row: UserKeycloak) {
    this.router.navigate(['pfa-interne/link-adherents'], {
      state: { data: row },
    });
  }

  /**
   * Highlights the selected tab and sets the others to the default state
   * @param {number} index - The index of the selected tab
   */
  onTabSelected(index: number): void {
    const menuElements = document.querySelectorAll('.menu-element');
    if (menuElements.length > 3 && index >= 0 && index < menuElements.length) {
      for (let i = 0; i < menuElements.length; i++) {
        const menuElement = menuElements[i] as HTMLElement;
        if (i === index) {
          menuElement.classList.remove('menu-element--default');
          menuElement.classList.add('menu-element--highlighted');
        } else {
          menuElement.classList.remove('menu-element--highlighted');
          menuElement.classList.add('menu-element--default');
        }
      }
    }
  }
}
